import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeWidget from '@/views/WebChat/HomeWidget.vue'
import HomeBox from '@/views/InternChat/HomeBox.vue'
import HomeFull from '@/views/InternChatFull/HomeBox.vue'
import AuditHome from '@/views/Audit/HomeAudit.vue'
import HomeWebChatFull from '@/views/WebChatFull/HomeWebChatFull.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'webchat',
    component: HomeWidget
  },
  {
    path: '/web-chat-full',
    name: 'WebChatFull',
    component: HomeWebChatFull
  },
  {
    path: '/internal',
    name: 'chat.internal',
    component: HomeBox
  },
  {
    path: '/internalFull',
    name: 'chat.internal.full',
    component: HomeFull
  },
  {
    path: '/internalAudit',
    name: 'audit.home',
    component: AuditHome,
    meta: { title: 'Auditoria' }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router
